import Route from '@ember/routing/route';
import { service } from '@ember/service';
import type ReimaginedDataService from 'tio-employee/services/reimagined-data';
import type SessionContextService from 'tio-employee/services/session-context';
import type TuitionAssistanceService from 'tio-common/services/tuition-assistance';

export default class AuthenticatedReimaginedLoansIndexRoute extends Route {
  @service declare reimaginedData: ReimaginedDataService;
  @service declare sessionContext: SessionContextService;
  @service declare tuitionAssistance: TuitionAssistanceService;

  async model() {
    const employee = this.sessionContext.currentEmployee;
    const limitsStatusPromise = employee
      ? this.tuitionAssistance.getV2SlrLimitsStatus(employee, employee.plan?.id ?? undefined)
      : undefined;

    const [
      loansData,
      dataSourceInfo,
      employerContributions,
      section127Info,
      contributionHistory,
      limitsStatus,
    ] = await Promise.all([
      this.reimaginedData.fetchLoansData(),
      this.reimaginedData.getDataSourceInfo(),
      this.reimaginedData.fetchEmployerContributions(),
      this.reimaginedData.fetchSection127Info(),
      this.reimaginedData.fetchContributionHistory(),
      limitsStatusPromise,
    ]);

    // Check if user has run strategy finder before
    const hasStrategyFinderResults = (employee?.strategyFinderResults?.length ?? 0) > 0;

    return {
      ...loansData,
      dataSourceInfo,
      employerContributions,
      section127Info,
      contributionHistory,
      limitsStatus,
      hasStrategyFinderResults,
    };
  }
}
